import { ThemeProvider } from '@material-ui/core/styles'
import withProvider from '../withProvider'
import defaultTheme from './themes'

const withMaterialProvider = (theme = defaultTheme) => withProvider(ThemeProvider, { theme })

export default withMaterialProvider
